import React from 'react';
import {Box, Grid, Stack, Typography} from "@mui/material";
import {useTheme} from "@mui/material/styles";

const BasePage = ({children}) => {
  const theme = useTheme()
  return (
    <Box
      width={'100%'}
      sx={{ px: { xs: 1, sm: 2 }, py: 1 }}
    >
      <Stack direction={'row'} mb={"-3em"}>
        <Typography
          sx={{
            position: 'relative',
            zIndex: 1,
            fontSize: 60,
            fontFamily: 'Monoton'
          }}
        >
          MHD
        </Typography>
        <Typography
          sx={{
            position: 'relative',
            top: '1em',
            right: '1em',

            mr: 1,
            borderRadius: '4px',
            zIndex: 2,
            fontSize: 40,

            color: 'darkred',
            textShadow: '5px 5px 4px rgba(0, 0, 0, 0.5)',
            fontFamily: 'Share'
          }}
        >
          web
        </Typography>
      </Stack>

      {children}
    </Box>
  );
};

export default BasePage;